export default {"src":"/_next/static/media/dark-nh-shape.e28ae8ef.svg","height":335,"width":292};